export default __webpack_public_path__ + "static/media/email.94ad9afd.svg";